import React, { useCallback, useEffect, useState } from "react";
import { Link, redirect, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import BookingDetailItem from "../booking/BookingDetailItem";
import BookingDetailItemIcon from "../booking/BookingDetailItemIcon";
import { resetAirlineView, viewAirline } from "src/store/reducers/airlines";
import AirlineFormCanvas from "./AirlineFormCanvas";

const ViewAirline = () => {
  const dispatch = useAppDispatch();

  const { id: airlineId } = useParams();

  const airlineViewStatus = useAppSelector((state) => state.airlines.view.status);
  const airlineData = useAppSelector((state) => state.airlines.view.data);
  const [editId, setEditId] = useState("");

  useEffect(() => {
    if (!airlineId) {
      redirect("/airlines");
    }
  }, [airlineId]);

  const retry = useCallback(() => {
    dispatch(viewAirline(airlineId));
  }, [airlineId, dispatch]);

  useEffect(() => {
    if (airlineViewStatus === "idle") {
      retry();
    }
  }, [airlineViewStatus, retry]);

  useEffect(() => {
    if (airlineData?.id !== airlineId) {
      dispatch(resetAirlineView());
    }
  }, [airlineData?.id, airlineId, dispatch]);

  return (
    <>
      <div className="container-fluid mh-auto">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                {airlineViewStatus === "success" && airlineData ? (
                  <div className="row">
                    <div className="col-xl-3 col-lg-3  col-md-3 col-sm-3">
                      <div className="about-me">
                        <ul>
                          <BookingDetailItemIcon
                            title={"Airline name"}
                            icon={"plane"}
                            value={airlineData.airline_name}
                          />
                          <BookingDetailItemIcon
                            icon={"phone"}
                            title={"Contact number"}
                            value={airlineData.contact_number}
                          />
                          <BookingDetailItemIcon
                            icon={"tag"}
                            title={"Airline code"}
                            value={airlineData.airline_code}
                          />
                          <BookingDetailItemIcon
                            icon={"user-md"}
                            title={"Contact person"}
                            value={airlineData.contact_person_name}
                          />
                        </ul>
                      </div>
                      <div className="d-flex mt-4 justify-content-end">
                        <Link
                          to={"#"}
                          onClick={() => setEditId(airlineData.id)}
                          className="modal-btn btn btn-primary btn-sm  ms-2"
                        >
                          <i className="fa-solid fa-pen-to-square me-1"></i>
                          Edit
                        </Link>
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-9  col-md-9 col-sm-9">
                      <div className="product-detail-content">
                        <div className=" pr">
                          <div className="row">
                            <div className="col-xl-6 col-lg-6  col-md-6 col-sm-6 c-details">
                              <ul>
                                <BookingDetailItem
                                  title={"Email"}
                                  value={airlineData.email_id}
                                />
                                <BookingDetailItem
                                  title={"Created"}
                                  value={new Date(
                                    airlineData.created_date
                                  ).toLocaleString('en-IN')}
                                />
                                <BookingDetailItem
                                  title={"Updated"}
                                  value={new Date(
                                    airlineData.updated_date
                                  ).toLocaleString('en-IN')}
                                />
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : airlineViewStatus === "pending" ||
                  airlineViewStatus === "idle" ? (
                  <div className="d-flex align-items-center">
                    <strong>Loading...</strong>
                    <div
                      className="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                ) : airlineViewStatus === "error" ? (
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={retry}
                    >
                      Retry
                    </button>{" "}
                    &nbsp;
                    <strong onClick={retry}>Please try again </strong>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {airlineData ? (
        <>
          <AirlineFormCanvas
            show={editId !== ""}
            hide={() => setEditId("")}
            editId={editId}
            Title={editId === "Add" ? "Add Airline" : "Edit Airline"}
            airlineData={airlineData}
          />
        </>
      ) : null}
    </>
  );
};

export default ViewAirline;
